import type { IconName } from "@similarweb/icons";

import SignalType from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalType";

export const iconNamePerSignalType: Record<SignalType, IconName> = {
    [SignalType.AdNetwork]: "ad",
    [SignalType.Technology]: "computer-settings",
    [SignalType.News]: "serp-news",
    [SignalType.Traffic]: "overview",
    [SignalType.Ecommerce]: "showcase-shopping",
    [SignalType.Intent]: "fire-outline",
    [SignalType.AdvertiserActivity]: "ad-research",
    [SignalType.Apps]: "sidebar3-search-apps",
    [SignalType.RoleChanges]: "employee-growth",
};
